<template>
  <div class="chat-box">
    <div class="chat-header">
      <div class="chat-header-left">
        <button @click="toggleExpand">
          <img src="@/assets/img/chatbot/chat/chat-border.svg" alt="message" />
        </button>
        <span>Conversación</span>
      </div>
      <button @click="toggleExpand">
        <img width="18" src="@/assets/img/chatbot/hidden.svg" alt="hidden" />
      </button>
    </div>

    <div class="db-buttons">
      <button @click="changeTypeChat('file')">
        <img src="@/assets/img/chatbot/chat/chat.svg" alt="Sube Documentos" />
        <span>Sube Documentos</span>
      </button>
      <button @click="changeTypeChat('db')">
        <img src="@/assets/img/chatbot/chat/db.svg" alt="Analiza tus Datos" />
        <span>Analiza tus Datos</span>
      </button>
    </div>

    <div class="chat-voice-container">
      <div v-if="!callStarted" class="start-call">
        <img src="@/assets/img/tel.svg" alt="tel de IA" />
        <p class="start-text">Inicia una llamada con IA</p>
        <button class="start-call-button" @click="startCall">Iniciar llamada</button>
      </div>

      <div v-else class="call-active-container">
        <div class="ai-circle-container">
          <div class="ai-circle" :class="{ listening: isMicActive && !micMuted, thinking: awaitingResponse }">
            <img src="@/assets/img/chelita-3d.png" alt="Asistente de IA" class="ai-avatar" />
          </div>
        </div>

        <div class="call-status">
          <p v-if="awaitingResponse" class="waiting-msg">Esperando respuesta de la IA...</p>
          <audio ref="remoteAudio" autoplay></audio>

          <div v-if="showAudioPermissionMessage" class="permission-message">
            <p class="permission-text">No se pudo reproducir el audio. Verifica los permisos de tu navegador.</p>
            <div v-if="showAudioPermissionMessage" class="permission-message">
              <p class="permission-text">No se pudo reproducir el audio. Verifica los permisos de tu navegador.</p>
              <button class="enable-audio-button" @click="requestAudioPermission">
                Habilitar audio
              </button>
            </div>
          </div>
        </div>

        <div class="call-controls">
          <button class="mic-button" @click="toggleMute">
            <img :src="micMuted
              ? require('@/assets/img/chatbot/mic-off-svgrepo-com.svg')
              : require('@/assets/img/chatbot/mic-svgrepo-com.svg')" alt="mic" class="mic-icon" />
          </button>

          <button class="end-call-button" @click="endCall">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'webrtc-adapter';
import { mapMutations } from 'vuex';

export default {
  name: "ChatFaq",
  data() {
    return {
      newMessage: "",
      chatHistory: [],
      isMicActive: false,
      micMuted: false,
      callStarted: false,
      recognition: null,
      ws: null,
      peerConnection: null,
      localStream: null,
      thinkingMessageIndex: null,
      awaitingResponse: false,
      showAudioPermissionMessage: false,
      audioContext: null,
      currentAudio: null,
      servers: {
        iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
      },
    };
  },
  methods: {
    ...mapMutations(['SET_CHAT_TYPE']),

    changeTypeChat(type) {
      this.SET_CHAT_TYPE(type);
    },
    toggleExpand() {
      this.$router.push("/");
    },

    async initAudioContext() {
      try {
        if (!this.audioContext) {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          this.audioContext = new AudioContext();

          if (this.audioContext.state === 'suspended') {
            await this.audioContext.resume();
          }
        }
        return true;
      } catch (e) {
        console.error("Error initializing audio:", e);
        return false;
      }
    },

    async playAudio(audioUrl) {
      try {
        await this.initAudioContext();

        if (this.currentAudio) {
          this.currentAudio.pause();
          this.currentAudio = null;
        }

        const audio = new Audio(audioUrl);
        this.currentAudio = audio;

        await audio.play();
        this.showAudioPermissionMessage = false;
      } catch (e) {
        console.warn("Audio play failed:", e);
        this.showAudioPermissionMessage = true;
      }
    },

    async startCall() {
      try {
        this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        await this.initAudioContext();

        this.callStarted = true;
        this.isMicActive = true;
        this.micMuted = false;
        this.showAudioPermissionMessage = false;

        this.chatHistory.push({
          from: "bot",
          type: "text",
          text: "Hola, puedes hablar o escribir tu pregunta.",
        });

        this.connectWebSocket();

        // WebRTC config
        this.peerConnection = new RTCPeerConnection(this.servers);
        this.localStream.getTracks().forEach(track => {
          this.peerConnection.addTrack(track, this.localStream);
        });

        this.peerConnection.onicecandidate = (event) => {
          if (event.candidate) {
            this.ws.send(JSON.stringify({ candidate: event.candidate }));
          }
        };

        this.peerConnection.ontrack = (event) => {
          const [remoteStream] = event.streams;
          const audioElement = this.$refs.remoteAudio;
          audioElement.srcObject = remoteStream;
        };

        this.startRecognition();
      } catch (err) {
        alert("Debes permitir el uso del micrófono para continuar con la llamada.");
      }
    },

    endCall() {
      this.callStarted = false;
      this.isMicActive = false;
      this.micMuted = false;

      if (this.recognition) this.recognition.stop();
      if (this.ws) this.ws.close();
      if (this.peerConnection) this.peerConnection.close();
      if (this.localStream) {
        this.localStream.getTracks().forEach(track => track.stop());
        this.localStream = null;
      }

      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }
    },

    toggleMute() {
      this.micMuted = !this.micMuted;
      if (this.micMuted) {
        if (this.recognition) {
          this.recognition.abort();
          this.isMicActive = false;
        }
      } else {
        if (this.callStarted) {
          this.startRecognition();
        }
      }
    },

    async requestAudioPermission() {
      try {
        this.showAudioPermissionMessage = false;
        const audio = new Audio();
        await audio.play();

        this.showAudioPermissionMessage = false;

        if (this.currentAudio) {
          await this.currentAudio.play();
        }
      } catch (err) {
        console.error("Error al solicitar permisos de audio:", err);
        alert("Por favor, habilita manualmente los permisos de audio en tu navegador.");
      }
    },

    connectWebSocket() {
      this.ws = new WebSocket("wss://api-qa.chelita.com.mx/voice-agent/ws/chat");

      this.ws.onmessage = async (event) => {
        const data = JSON.parse(event.data);

        if (data.offer) {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(data.offer));
          const answer = await this.peerConnection.createAnswer();
          await this.peerConnection.setLocalDescription(answer);
          this.ws.send(JSON.stringify({ answer }));
        }

        if (data.answer) {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(data.answer));
        }

        if (data.candidate) {
          await this.peerConnection.addIceCandidate(new RTCIceCandidate(data.candidate));
        }

        if (data.response && data.audio) {
          if (this.thinkingMessageIndex !== null) {
            this.chatHistory[this.thinkingMessageIndex] = {
              from: "bot",
              type: "text",
              text: data.response,
            };
            this.thinkingMessageIndex = null;
          }

          const audioData = Uint8Array.from(data.audio.match(/.{1,2}/g).map(b => parseInt(b, 16)));
          const blob = new Blob([audioData], { type: "audio/mp3" });
          const audioUrl = URL.createObjectURL(blob);

          await this.playAudio(audioUrl);
          this.awaitingResponse = false;
        }
      };
    },

    sendMessage() {
      if (this.newMessage.trim()) {
        const userMsg = this.newMessage.trim();

        this.chatHistory.push({
          from: "me",
          type: "text",
          text: userMsg,
        });

        this.chatHistory.push({
          from: "bot",
          type: "text",
          text: "Pensando...",
          thinking: true,
        });

        this.thinkingMessageIndex = this.chatHistory.length - 1;
        this.ws.send(JSON.stringify({ message: userMsg }));

        this.awaitingResponse = true;
        this.newMessage = "";
      }
    },

    startRecognition() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        alert("Tu navegador no soporta reconocimiento de voz.");
        return;
      }

      if (!this.recognition) {
        this.recognition = new SpeechRecognition();
        this.recognition.lang = "es-ES";
        this.recognition.continuous = true;
        this.recognition.interimResults = true;
        this.recognition.maxAlternatives = 1;

        this.silenceTimeout = null;
        const SILENCE_DELAY = 2000;

        this.recognition.onresult = (event) => {
          if (this.awaitingResponse) return;

          if (this.silenceTimeout) {
            clearTimeout(this.silenceTimeout);
          }

          let transcript = "";
          let isFinal = false;

          for (let i = event.resultIndex; i < event.results.length; ++i) {
            transcript += event.results[i][0].transcript;
            if (event.results[i].isFinal) {
              isFinal = true;
            }
          }

          const text = transcript.trim();
          if (text) {
            this.newMessage = text;

            if (isFinal) {
              this.sendMessage();
            } else {
              this.silenceTimeout = setTimeout(() => {
                if (this.newMessage.trim() && !this.awaitingResponse) {
                  this.sendMessage();
                }
              }, SILENCE_DELAY);
            }
          }
        };

        this.recognition.onerror = (e) => {
          console.error("Reconocimiento de voz error:", e);
          if (e.error === 'no-speech') {
            if (!this.micMuted && this.callStarted) {
              setTimeout(() => {
                this.recognition.start();
              }, 500);
            }
          }
        };

        this.recognition.onend = () => {
          if (!this.micMuted && this.callStarted) {
            this.recognition.start();
          }
        };
      }

      try {
        this.recognition.start();
        this.isMicActive = true;
      } catch (err) {
        console.warn("No se pudo iniciar el reconocimiento de voz:", err);
      }
    }
  },

  beforeUnmount() {
    if (this.silenceTimeout) {
      clearTimeout(this.silenceTimeout);
    }
    this.endCall();
  }
};
</script>


<style scoped>
.db-buttons {
  display: none;
  gap: 16px;
}

.db-buttons button {
  padding: 10px 7rem;
  background: transparent;
  color: #7a94b2;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.chat-box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #061821;
  overflow: hidden;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #17181B;
  border-bottom: 1px solid #2a2b2e;
}

.chat-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-header button {
  background: none;
  border: none;
  cursor: pointer;
}

.chat-header span {
  color: white;
  font-weight: bold;
  font-size: 1.1rem;
}

.chat-voice-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  gap: 1rem;
  background-color: #061821;
  color: #f8fafc;
}

.start-call {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 400px;
  margin: 0 auto;
}

.start-text {
  color: #e2e8f0;
  font-size: small;
  font-weight: bold;
  margin: 0;
}



.start-call-button {
  background-color: #136C94;
  color: white;
  padding: 0.8rem 5rem;
  font-size: 1rem;
  font-weight: 300;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.start-call-button:hover {
  background-color: #136C94;
  transform: translateY(-1px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.call-active-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  width: 100%;
}

.ai-circle-container {
  position: relative;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ai-avatar {
  width: 70%;
  height: 70%;
  object-fit: contain;
  filter: brightness(0.9);
  transition: all 0.3s ease;
}

.ai-circle.listening {
  animation: pulse 1.2s infinite;
}

.ai-circle.listening .ai-avatar {
  filter: brightness(1.1) drop-shadow(0 0 8px rgba(59, 130, 246, 0.6));
}

.ai-circle.thinking {
  background-color: #334155;
  animation: thinking-glow 2s infinite;
}

.ai-circle.thinking .ai-avatar {
  filter: brightness(1.05) drop-shadow(0 0 12px rgba(255, 255, 255, 0.4));
}

.permission-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.enable-audio-button {
  padding: 8px 16px;
  background-color: #136C94;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.enable-audio-button:hover {
  background-color: #136C94;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0px rgba(59, 130, 246, 0.3);
  }

  50% {
    box-shadow: 0 0 30px rgba(59, 130, 246, 0.7);
  }

  100% {
    box-shadow: 0 0 0px rgba(59, 130, 246, 0.3);
  }
}

@keyframes thinking-glow {
  0% {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
  }

  50% {
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  }

  100% {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
  }
}

.call-controls {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.mic-button {
  background: #334155;
  border: none;
  cursor: pointer;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.mic-button:hover {
  background: #475569;
  transform: scale(1.05);
}

.mic-icon {
  width: 60%;
  height: 60%;
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.end-call-button {
  background-color: #ef4444;
  color: white;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.end-call-button:hover {
  background-color: #dc2626;
  transform: scale(1.05);
}

.end-call-button svg {
  width: 24px;
  height: 24px;
  fill: white;
}

.call-status {
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.waiting-msg {
  color: #94a3b8;
  font-size: 1rem;
  margin: 0;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background-color: rgba(30, 41, 59, 0.5);
}

.permission-message {
  position: fixed;
  bottom: 80px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 1000;
  padding: 1rem;
  border-radius: 8px;
  max-width: 80%;
}

.permission-text {
  color: #e2e8f0;
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.5;
}

@media (max-width: 480px) {
  .chat-header {
    background-color: #061821;
  }

  .chat-voice-container {
    padding: 1.5rem;
  }

  .ai-circle-container {
    width: 140px;
    height: 140px;
  }

  .call-controls {
    gap: 1rem;
  }

  .mic-button,
  .end-call-button {
    width: 52px;
    height: 52px;
  }

  .db-buttons {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-top: 1.5rem;
  }

  .db-buttons button {
    display: flex;
    align-items: center;
    gap: 3px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 14px;
    padding: 12px;
    transition: all 0.2s ease;
  }

  .db-buttons button:hover {
    color: #47A4D0;
  }

  .db-buttons img {
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
  }
}
</style>